import React from 'react';
import { Avatar, Flex } from 'antd';
import { faUsers } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { bytesToBase64 } from 'jf/pages/studyBuilder/targetRespondents/msteams/MSTeamsFunctions';

export const getMsteamsImageSrc = (imageBytes) => {
  const imageString = bytesToBase64(imageBytes);
  return imageString ? (
    <img src={`data:image/jpeg;base64, ${imageString}`} alt="profilePhoto" />
  ) : (
    <FontAwesomeIcon icon={faUsers} />
  );
};

export const MSTeamsEntityCard = ({ name, displayName, imageBytes, disabled = false }) => {
  const theme = useDevExTheme();

  return (
    <Flex
      gap={theme.variable.spacing.sm}
      align="center"
      style={{ opacity: disabled ? theme.variable.opacity.disabled : 1 }}
    >
      <Avatar
        shape={'square'}
        style={{ backgroundColor: theme.color.background.active }}
        size="large"
        src={getMsteamsImageSrc(imageBytes)}
      />
      <Flex vertical align="flex-start">
        {name}
        <div style={{ color: theme.color.text.secondary }}> {`@${displayName}`}</div>
      </Flex>
    </Flex>
  );
};
